import { View } from 'react-native'

import type { PostPaymentOnboardingStep } from '../types'

const PROGRESS_BAR_HEIGHT = 9

interface PostPaymentStepProgressProps {
  step: PostPaymentOnboardingStep
  totalSteps: number | null
}

function getStepIndex(step: PostPaymentOnboardingStep): number {
  return step === 'details' ? 2 : 1
}

export function PostPaymentStepProgress({
  step,
  totalSteps,
}: PostPaymentStepProgressProps) {
  const stepIndex = getStepIndex(step)
  if (totalSteps == null) {
    return (
      <View
        className="flex-row items-center gap-2"
        style={{ height: PROGRESS_BAR_HEIGHT }}
      />
    )
  }

  const visibleStepCount = Math.max(totalSteps, stepIndex)
  const stepNumbers = Array.from(
    { length: visibleStepCount },
    (_, index) => index + 1,
  )

  return (
    <View className="flex-row items-center gap-2">
      {stepNumbers.map((stepNumber) => (
        <View
          key={`onboarding-progress-${stepNumber}`}
          className={`flex-1 rounded-full ${stepNumber <= stepIndex ? 'bg-primary' : 'bg-border'}`}
          style={{ height: PROGRESS_BAR_HEIGHT }}
        />
      ))}
    </View>
  )
}
